import { render, staticRenderFns } from "./SupplierRawMaterialAdditionalInformation.vue?vue&type=template&id=13253b75&scoped=true&"
import script from "./SupplierRawMaterialAdditionalInformation.vue?vue&type=script&lang=js&"
export * from "./SupplierRawMaterialAdditionalInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13253b75",
  null
  
)

export default component.exports